import BEM from 'bem.js';
import { AddressConsumer } from '../data/address/address';


const BLOCK_INPUT = 'input';

const ELEMENT_POSTCODE = 'postcode';
const ELEMENT_NUMBER = 'number';
const ELEMENT_ADDITION = 'addition';
const ELEMENT_STREET = 'street';
const ELEMENT_CITY = 'city';


class AddressChanger {
    constructor() {
        this.post_code_field = BEM.getBEMNode(BLOCK_INPUT, ELEMENT_POSTCODE);
        this.number_field = BEM.getBEMNode(BLOCK_INPUT, ELEMENT_NUMBER);
        this.addition_field = BEM.getBEMNode(BLOCK_INPUT, ELEMENT_ADDITION);
        this.street_field = BEM.getBEMNode(BLOCK_INPUT, ELEMENT_STREET);
        this.city_field = BEM.getBEMNode(BLOCK_INPUT, ELEMENT_CITY);
        this.addressConsumer = new AddressConsumer();

        this.post_code = null;
        this.number = null;
        this.addition = null;

        this.addChange();
    }

    addChange() {
        if(this.post_code_field) {
            this.post_code_field.addEventListener('change', (e) => {
                this.post_code = e.target.value;
                this.updateAddress();
            });
            let event = new CustomEvent('change');
            this.post_code_field.dispatchEvent(event);
        }

        if(this.number_field) {
            this.number_field.addEventListener('change', (e) => {
                this.number = e.target.value;
                this.updateAddress();
            });
            let event = new CustomEvent('change');
            this.number_field.dispatchEvent(event);
        }

        if(this.addition_field) {
            this.addition_field.addEventListener('change', (e) => {
                this.addition = e.target.value;
                this.updateAddress();
            });
            let event = new CustomEvent('change');
            this.addition_field.dispatchEvent(event);
        }
    }

    updateAddress() {
        if(this.post_code && this.number) {
            this.addressConsumer.getAddressDetails(this.post_code, this.number, this.addition)
            .then(this.fillNewAddress.bind(this));
        }
    }

    fillNewAddress(address) {
        if(this.street_field && address.street) {
            this.street_field.value = address.street;
        }

        if(this.city_field && address.city) {
            this.city_field.value = address.city;
        }
    }
}


new AddressChanger();



// WEBPACK FOOTER //
// ./src/my_artis/js/components/address.js